import { MapPin, Phone, Mail, Clock } from 'lucide-react'

export default function Footer() {
  return (
    <div className="bg-blue-900 text-white p-6 md:p-8 lg:p-10 shadow-lg mx-auto w-full font-tommy-regular mt-10">
      <h2 className="text-2xl md:text-3xl font-bold mb-6">Información de Contacto</h2>
      <div className="space-y-4">
        <div className="flex items-start">
          <MapPin className="w-6 h-6 mr-3 flex-shrink-0 mt-1" />
          <div>
            <h3 className="mb-1">Dirección:</h3>
            <p className="text-sm md:text-base">
              4ta. Avenida 2-25, zona 1, Plaza Central, Edificio de Gobernación Departamental, Nivel II
            </p>
          </div>
        </div>
        <div className="flex items-center">
          <Phone className="w-6 h-6 mr-3 flex-shrink-0" />
          <div>
            <h3 className="mb-1">Teléfono:</h3>
            <p className="text-sm md:text-base">(502) 7764-1034</p>
          </div>
        </div>
        <div className="flex items-center">
          <Mail className="w-6 h-6 mr-3 flex-shrink-0" />
          <div>
            <h3 className="mb-1">Correo:</h3>
            <p className="text-sm md:text-base">codedeh20@gmail.com</p>
          </div>
        </div>
        <div className="flex items-start">
          <Clock className="w-6 h-6 mr-3 flex-shrink-0 mt-1" />
          <div>
            <h3 className="mb-1">Horario:</h3>
            <p className="text-sm md:text-base">De Lunes a Viernes de 07:00 a 15:30 horas</p>
          </div>
        </div>
      </div>
    </div>
  )
}